import "core-js/modules/es6.regexp.split";
import _slicedToArray from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.function.name";
import FormMixin from "../mixins/form-validate";
import Axios from "axios";
import UserRegister from "./UserRegister.vue";
import loginTool from "../config/loginTool";
export default {
  name: 'login',
  components: {
    UserRegister: UserRegister
  },
  mixins: [FormMixin],
  data: function data() {
    return {
      loading: false,
      form: {
        username: "",
        password: ""
      },
      formRules: {
        username: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        },
        password: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        }
      },
      showRegisterModal: false
    };
  },
  methods: {
    submit: function submit() {
      var _this = this;
      if (!this.isFormValid) {
        return;
      }
      this.loading = true;
      Axios.get("csrftoken/").then(function () {
        return Axios.post("users/auth/", {
          username: _this.form.username,
          password: _this.form.password
        });
      }).then(function (resp) {
        _this.loading = false;
        var user = resp.data.user;
        _this.login(user);
      }, function (e) {
        _this.loading = false;
        throw e;
      });
    },
    login: function login(user) {
      var _loginTool$getLoginIn = loginTool.getLoginInfo(user),
        authHash = _loginTool$getLoginIn.authHash,
        menuHash = _loginTool$getLoginIn.menuHash,
        activePath = _loginTool$getLoginIn.activePath;
      this.$store.commit('updateLoginInfo', {
        user: user,
        authHash: authHash,
        menuHash: menuHash
      });

      // 优先访问顺序
      var visitList = ['TrialSheetReview', 'TrialSheet', 'SNSList', 'UserManage'];
      for (var i = 0; i < visitList.length; i++) {
        var name = visitList[i];
        var menu = menuHash[name];
        if (menu) {
          activePath = menu.path;
          break;
        }
      }
      this.$router.push(activePath);
    }
  },
  created: function created() {
    if (process.env.NODE_ENV === "development" && localStorage.login) {
      var _localStorage$login$s = localStorage.login.split("/"),
        _localStorage$login$s2 = _slicedToArray(_localStorage$login$s, 2),
        username = _localStorage$login$s2[0],
        password = _localStorage$login$s2[1];
      this.form.username = username;
      this.form.password = password;
      this.isFormValid = true;
      this.submit();
    }
  }
};